import Cookies from 'js-cookie'

const TokenKey = 'Bearer__' + process.env.REACT_APP_PROJECT
const UserKey = 'UserInfo__' + process.env.REACT_APP_PROJECT
const UserIdKey = 'UserId__' + process.env.REACT_APP_PROJECT
const ExpiredTime = 7

export function setUserId(userId, group) {
  let key = UserIdKey
  if (group) {
    key = `${key}__${group}`
  }
  return Cookies.set(key, userId, {
    expires: ExpiredTime,
    samesite: 'None',
    secure: 'true'
  })
}
export function getUserId(group) {
  let key = UserIdKey
  if (group) {
    key = `${key}__${group}`
  }
  return Cookies.get(key)
}
export function removeUserId() {
  return Cookies.remove(UserIdKey)
}

export function setUser(user, group) {
  let key = UserKey
  if (group) {
    key = `${key}__${group}`
  }
  return Cookies.set(key, user, {
    expires: ExpiredTime,
    samesite: 'None',
    secure: 'true'
  })
}
export function getUser(group) {
  let key = UserKey
  if (group) {
    key = `${key}__${group}`
  }
  return Cookies.get(key)
}
export function removeUser() {
  return Cookies.remove(UserKey)
}

export function getToken(group) {
  let key = TokenKey
  if (group) {
    key = `${key}__${group}`
  }
  return Cookies.get(key)
}
export function setToken(token, group) {
  let key = TokenKey
  if (group) {
    key = `${key}__${group}`
  }
  return Cookies.set(key, token, {
    expires: ExpiredTime,
    samesite: 'None',
    secure: 'true'
  })
}
export function removeToken() {
  return Cookies.remove(TokenKey)
}
